import { Card } from "@secretaa/ui";
import { useTranslation } from "react-i18next";
import { Outlet } from "react-router";
import { LocaleSwitch } from "./locale-switch.tsx";

export function AuthLayout() {
  const { t } = useTranslation();
  return (
    <div className="flex min-h-full flex-col items-center justify-center gap-6 px-4 py-10">
      <div className="flex w-full max-w-sm items-center justify-between">
        <span className="text-lg font-semibold">{t("app.name")}</span>
        <LocaleSwitch />
      </div>
      <main id="main" className="w-full max-w-sm">
        <Card>
          <Outlet />
        </Card>
      </main>
    </div>
  );
}
